import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Flame, Phone } from 'lucide-react';
export function Popup() {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    // Show popup after 4 seconds
    const timer = setTimeout(() => {
      setIsOpen(true);
    }, 4000);
    return () => clearTimeout(timer);
  }, []);
  return <AnimatePresence data-id="element-182">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" data-id="element-183">
          <motion.div initial={{
        scale: 0.9,
        opacity: 0,
        y: 20
      }} animate={{
        scale: 1,
        opacity: 1,
        y: 0
      }} exit={{
        scale: 0.9,
        opacity: 0,
        y: 20
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 300
      }} className="relative w-full max-w-md bg-[#0a0a0a] border border-white/10 rounded-3xl p-8 shadow-[0_20px_60px_-15px_rgba(255,149,0,0.3)] overflow-hidden" data-id="element-184">
            {/* Decorative Background Elements */}
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-primary" data-id="element-185"></div>
            <div className="absolute -top-20 -right-20 w-40 h-40 bg-[#FF9500] rounded-full blur-[80px] opacity-20 pointer-events-none" data-id="element-186"></div>

            <button onClick={() => setIsOpen(false)} className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-white/5 text-gray-400 hover:text-white hover:bg-white/10 transition-colors" aria-label="Close popup" data-id="element-187">
              <X className="w-4 h-4" data-id="element-188" />
            </button>

            <div className="w-12 h-12 rounded-full bg-gradient-primary p-[1px] mb-6 shadow-lg" data-id="element-189">
              <div className="w-full h-full bg-[#0a0a0a] rounded-full flex items-center justify-center" data-id="element-190">
                <Flame className="w-6 h-6 text-[#FF9500]" data-id="element-191" />
              </div>
            </div>

            <h3 className="text-2xl font-black text-white mb-2" data-id="element-192">
              Need an Emergency Repair?
            </h3>
            <p className="text-gray-400 mb-8 leading-relaxed text-sm" data-id="element-193">
              Our Gas Safe engineers are available 24/7 across Glasgow and
              Clydeside. Don't stay in the cold — we're ready to help right now.
            </p>

            <div className="flex flex-col gap-3" data-id="element-194">
              <a href="tel:07845242803" className="flex items-center justify-center gap-2 bg-gradient-primary text-black font-bold py-3.5 rounded-xl hover:shadow-[0_0_25px_rgba(255,149,0,0.4)] transition-all transform hover:-translate-y-0.5" data-id="element-195">
                <Phone className="w-5 h-5" data-id="element-196" />
                Call 07845 242803
              </a>
              <button onClick={() => setIsOpen(false)} className="text-sm font-medium text-gray-500 hover:text-white transition-colors py-2" data-id="element-197">
                No thanks, maybe later
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}